(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5563],{

/***/ 90017:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support",
      function () {
        return __webpack_require__(63862);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 63862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ SupportPage; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 295 modules
var shared_src = __webpack_require__(88805);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 120 modules
var ui_src = __webpack_require__(99313);
;// CONCATENATED MODULE: ../../../libs/landing/feature-support/src/lib/data/content.ts
const supportContactContent = {
    whatsAppHeading: "WhatsApp us",
    whatsAppHref: "https://wa.me/447831910589",
    smsHref: "sms:+442033224567",
    whatsAppBody: "Message one of our friendly team. They’re online Mon–Sat from 8am to 6pm.",
    whatsAppCta: "WhatsApp",
    textHeading: "Text us",
    textBody: "Message one of our friendly team. They’re online Mon–Sat from 8am to 6pm.",
    textCta: "Text",
    emailHeading: "Email us",
    emailBody: "Got a question? Email us and we’ll get back to you.",
    emailCta: "hello@cinch.co.uk",
    emailHref: "mailto:hello@cinch.co.uk",
    callHeading: "Call us",
    callBody: "Prefer to talk to someone on the phone? For sales enquiries lines are open Mon–Sat 8am–6pm and Sun 10am-4pm. For aftersales enquiries, lines are open Mon–Sat 8am–6pm.",
    callCta: "0333 015 4101",
    complaintsEmailCta: "complaints@cinch.co.uk",
    complaintsAddress: "Cinch Cars Limited, Form 2, 18 Bartley Wood Business Park, Bartley Way, Hook, Hampshire RG27 9XA",
    complaintsHeading1: "If you’ve got a complaint here’s what to do:",
    complaintsParagraphs1: [
        "At cinch, because every customer is important to us we aim to provide a quick, courteous, and fair resolution to any customer complaint.",
        "If something isn’t right then we want to hear about it so we can get it resolved for you as quickly as possible.",
        "In order to make a complaint you can contact us by one of the following methods:"
    ],
    complaintsHeading2: "What happens next:",
    complaintsParagraphs2: [
        "We will need to complete some Data Protection checks, and then we will take details from you about what went wrong, so we can investigate your complaint and work out what we need to do to put things right.",
        "If we can resolve your complaint within 3 days, we will do so, and then email you to confirm we have closed the complaint and the actions taken.",
        "If things are a little more complicated and are going to take longer to put right, we will email you to acknowledge your complaint in writing and set out the next steps.",
        "If we cannot resolve your complaint, we will issue you a Final Response Letter. This will detail which of the following escalation options may apply to you and any timescales in which you will need to refer your complaint.",
        'If we are unable to resolve your complaint in respect of goods supplied by us, you may refer the matter for independent Alternative Dispute Resolution (ADR) to South Yorkshire Trading Standards Services. You can find more information about them <a href="http://www.doncaster.gov.uk/services/business-investment/alternative-dispute-resolution-for-consumers" target="_blank" aria-label="Alternative Dispute Resolution">here</a>.',
        `If we are unable to resolve your complaint in respect of regulated activity, (for example where we have acted as a credit broker) you may refer the matter for independent Alternative Dispute Resolution (ADR) to The Financial Ombudsman Service. You can find more information about them <a href="https://www.financial-ombudsman.org.uk/" target="_blank" aria-label="The Financial Ombudsman Service">here</a>.`,
        `We will abide by any final decision made by either South Yorkshire Trading Standards or the Financial Ombudsman Service.`
    ],
    pressHeading: "Press enquiries",
    pressBody: "For any media enquiries whatsoever, please email",
    pressCta: "press@cinch.co.uk",
    faqHeading: "Got a Q? We’ve got the A",
    faqBody: "Find everything from how we pick our cars to the different ways you can pay for one.",
    addressHeading: "Address",
    address: {
        organisationName: "Cinch Cars Limited",
        buildingName: "Form 2, 18 Bartley Wood Business Park,",
        thoroughfare: "Bartley Way, Hook,",
        postTown: "Hampshire",
        postcode: "RG27 9XA",
        country: "UK"
    },
    companyRegistrationInformation: "Registered in England and Wales with company number 11520330 and VAT registration number 360909784",
    footerHeading: "Let's find your next car",
    footerCta: "Search"
};
const mockFaqs = [
    {
        _uid: "bba3a09c-8363-4a7a-b163-6cef3153a5a8",
        faqs: [
            {
                _uid: "754c4926-8bba-40b8-8c59-b7037a437eda",
                body: {
                    type: "doc",
                    content: [
                        {
                            type: "paragraph",
                            content: [
                                {
                                    text: "No, we don’t sell new cars. But every car we sell online is thoroughly inspected and carefully reconditioned by highly trained technicians – so you can be certain you’re buying a quality car.",
                                    type: "text"
                                }
                            ]
                        }
                    ]
                },
                title: "Do cinch offer new cars?",
                component: "AccordionItem"
            }
        ],
        title: "cinch cars…what to expect",
        component: "FaqSection"
    }
];

// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../libs/landing/feature-support/src/lib/components/address/support-address.module.css
var support_address_module = __webpack_require__(39903);
var support_address_module_default = /*#__PURE__*/__webpack_require__.n(support_address_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-support/src/lib/components/address/support-address.tsx





const SupportAddress = ()=>{
    const { addressHeading , address: { organisationName , buildingName , thoroughfare , postTown , postcode , country  } , companyRegistrationInformation  } = supportContactContent;
    const addressDetails = [
        organisationName,
        buildingName,
        thoroughfare,
        `${postTown} ${postcode} ${country}`,
        companyRegistrationInformation
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: (support_address_module_default()).sectionContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (support_address_module_default()).textWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        element: "h2",
                        fontSize: "xxl",
                        fontWeight: "bold",
                        lineHeight: "display",
                        children: addressHeading
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("address", {
                    children: addressDetails.map((addressDetail)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSize: "xs",
                                fontWeight: "book",
                                children: addressDetail
                            })
                        }, addressDetail))
                })
            ]
        })
    });
};
/* harmony default export */ var support_address = (SupportAddress);

// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
// EXTERNAL MODULE: ../../../node_modules/classnames/index.js
var classnames = __webpack_require__(95685);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../../../libs/landing/feature-support/src/lib/helpers/helpers.tsx

const handleTrackingClick = (trackEvent, data)=>{
    trackEvent({
        eventName: data.eventName,
        type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
        data: {
            event: {
                name: analytics_src/* EventNames.click */.Vy.click,
                category: data.category,
                label: data.label,
                action: analytics_src/* EventNames.click */.Vy.click
            }
        }
    });
};

// EXTERNAL MODULE: ../../../libs/landing/feature-support/src/lib/components/complaints/complaints.module.css
var complaints_module = __webpack_require__(18086);
var complaints_module_default = /*#__PURE__*/__webpack_require__.n(complaints_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-support/src/lib/components/complaints/complaints.tsx







const Complaints = ()=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const { whatsAppHref , callCta , complaintsHeading1 , complaintsHeading2 , complaintsParagraphs1 , complaintsParagraphs2 , complaintsAddress , complaintsEmailCta , pressHeading , pressBody , pressCta  } = supportContactContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (complaints_module_default()).complaints,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (complaints_module_default()).textWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontSize: "m",
                            fontWeight: "semibold",
                            className: (complaints_module_default()).heading,
                            children: complaintsHeading1
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((complaints_module_default()).textWrapper, (complaints_module_default()).complaintsParagraphsWrapper),
                        children: complaintsParagraphs1 && complaintsParagraphs1.map((paragraph, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (complaints_module_default()).paragraph,
                                children: paragraph
                            }, index))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                        className: (complaints_module_default()).complaintsContactTable,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                fontSize: "s",
                                                fontWeight: "semibold",
                                                children: "Phone:"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: `tel:${callCta}`,
                                                "aria-label": callCta,
                                                className: (complaints_module_default()).link,
                                                onClick: ()=>handleTrackingClick(trackEvent, {
                                                        eventName: "Support - complaints phone click",
                                                        label: callCta,
                                                        category: "phone"
                                                    }),
                                                children: callCta
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                fontSize: "s",
                                                fontWeight: "semibold",
                                                children: "Email:"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: `mailto:${complaintsEmailCta}`,
                                                "aria-label": complaintsEmailCta,
                                                className: (complaints_module_default()).link,
                                                onClick: ()=>handleTrackingClick(trackEvent, {
                                                        eventName: "Support - complaints email click",
                                                        label: complaintsEmailCta,
                                                        category: "email"
                                                    }),
                                                children: complaintsEmailCta
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                fontSize: "s",
                                                fontWeight: "semibold",
                                                children: "Live Chat:"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: whatsAppHref,
                                                "aria-label": "whatsApp complaints link",
                                                className: (complaints_module_default()).link,
                                                onClick: ()=>handleTrackingClick(trackEvent, {
                                                        eventName: "Support - complaints whatsApp click",
                                                        label: whatsAppHref,
                                                        category: "live chat"
                                                    }),
                                                children: whatsAppHref
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                fontSize: "s",
                                                fontWeight: "semibold",
                                                children: "In Writing:"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                fontSize: "s",
                                                fontWeight: "book",
                                                className: (complaints_module_default()).complaintsAddress,
                                                children: complaintsAddress
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (complaints_module_default()).textWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontSize: "m",
                            fontWeight: "semibold",
                            className: (complaints_module_default()).heading,
                            children: complaintsHeading2
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((complaints_module_default()).textWrapper, (complaints_module_default()).complaintsParagraphsWrapper),
                        children: complaintsParagraphs2.map((paragraph, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (complaints_module_default()).paragraph,
                                dangerouslySetInnerHTML: {
                                    __html: paragraph
                                }
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (complaints_module_default()).press,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (complaints_module_default()).textWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontSize: "m",
                            fontWeight: "semibold",
                            className: (complaints_module_default()).heading,
                            children: pressHeading
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (complaints_module_default()).textWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (complaints_module_default()).paragraph,
                            children: pressBody
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: `mailto:${pressCta}`,
                        "aria-label": "press link",
                        className: (complaints_module_default()).link,
                        onClick: ()=>handleTrackingClick(trackEvent, {
                                eventName: "Support - complaints press click",
                                label: pressCta,
                                category: "email"
                            }),
                        children: pressCta
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var complaints = (Complaints);

;// CONCATENATED MODULE: ../../../libs/landing/feature-support/src/lib/assets/mail.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SvgMail = props => /*#__PURE__*/react.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 31.256 24.776"
}, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinejoin: "round",
  strokeLinecap: "round"
}, /*#__PURE__*/react.createElement("path", {
  d: "M4.24 1h22.776a2.855 2.855 0 0 1 2.847 2.847v17.082a2.855 2.855 0 0 1-2.847 2.847H4.24a2.855 2.855 0 0 1-2.847-2.847V3.847A2.855 2.855 0 0 1 4.24 1Z"
}), /*#__PURE__*/react.createElement("path", {
  d: "m29.863 3.847-14.235 9.965L1.393 3.847"
}))));
/* harmony default export */ var mail = (SvgMail);
;// CONCATENATED MODULE: ../../../libs/landing/feature-support/src/lib/assets/phone.svg
var _path;
function phone_extends() { phone_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return phone_extends.apply(this, arguments); }

const SvgPhone = props => /*#__PURE__*/react.createElement("svg", phone_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27 28"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M6.972 1.299a3.395 3.395 0 0 1 3.396 2.924 14.31 14.31 0 0 0 .783 3.136 3.388 3.388 0 0 1-.769 3.58l-.967.965.069.11a18.131 18.131 0 0 0 5.585 5.575l.112.069.974-.971a3.4 3.4 0 0 1 3.368-.833l.208.07c1.015.378 2.07.64 3.152.783 1.706.238 2.962 1.717 2.921 3.415v3.58a3.392 3.392 0 0 1-3.717 3.385A24.705 24.705 0 0 1 11.33 23.27a24.305 24.305 0 0 1-7.48-7.465A24.626 24.626 0 0 1 .015 4.994a3.391 3.391 0 0 1 3.374-3.695zm.022 2H3.39a1.392 1.392 0 0 0-1.386 1.499 22.621 22.621 0 0 0 3.528 9.925 22.327 22.327 0 0 0 6.876 6.863 22.7 22.7 0 0 0 9.877 3.511 1.392 1.392 0 0 0 1.518-1.393v-3.606a1.388 1.388 0 0 0-1.19-1.41 16.395 16.395 0 0 1-3.582-.89 1.398 1.398 0 0 0-1.469.309l-1.52 1.517a1 1 0 0 1-1.2.162 20.131 20.131 0 0 1-7.556-7.542 1 1 0 0 1 .163-1.203l1.516-1.513c.382-.385.504-.957.312-1.467a16.29 16.29 0 0 1-.891-3.566 1.392 1.392 0 0 0-1.393-1.196zM16.68 4.9a6.979 6.979 0 0 1 5.514 5.512 1 1 0 1 1-1.962.384 4.979 4.979 0 0 0-3.934-3.932A1 1 0 0 1 16.68 4.9zM16.482.104l.116.006a11.761 11.761 0 0 1 10.4 10.366 1 1 0 1 1-1.988.226 9.761 9.761 0 0 0-8.63-8.604 1 1 0 0 1 .102-1.994z"
})));
/* harmony default export */ var phone = (SvgPhone);
;// CONCATENATED MODULE: ../../../libs/landing/feature-support/src/lib/assets/smartphone.svg
var _defs, smartphone_g;
function smartphone_extends() { smartphone_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return smartphone_extends.apply(this, arguments); }

const SvgSmartphone = props => /*#__PURE__*/react.createElement("svg", smartphone_extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 27,
  viewBox: "0 0 20 27"
}, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null, ".a{fill:none;stroke:#2f2f2f;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), smartphone_g || (smartphone_g = /*#__PURE__*/react.createElement("g", {
  transform: "translate(-4 -1)"
}, /*#__PURE__*/react.createElement("rect", {
  className: "a",
  width: 18,
  height: 25,
  rx: 2,
  transform: "translate(5 2)"
}), /*#__PURE__*/react.createElement("path", {
  className: "a",
  d: "M14 22h0"
}))));
/* harmony default export */ var smartphone = (SvgSmartphone);
;// CONCATENATED MODULE: ../../../libs/landing/feature-support/src/lib/assets/whats-app.svg
var whats_app_path;
function whats_app_extends() { whats_app_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return whats_app_extends.apply(this, arguments); }

const SvgWhatsApp = props => /*#__PURE__*/react.createElement("svg", whats_app_extends({
  fill: "#fff",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25"
}, props), whats_app_path || (whats_app_path = /*#__PURE__*/react.createElement("path", {
  d: "M1.766 18.581A12.384 12.384 0 0 1 12.552 0a12.4 12.4 0 0 1 8.805 3.633A12.283 12.283 0 0 1 25 12.4a12.436 12.436 0 0 1-12.448 12.385h-.005A12.484 12.484 0 0 1 6.6 23.277L0 25zm5.516 2.677a10.369 10.369 0 0 0 5.266 1.435A10.336 10.336 0 0 0 22.9 12.4 10.323 10.323 0 0 0 12.558 2.1a10.293 10.293 0 0 0-8.77 15.768l.246.39-1.045 3.8L6.9 21.035zm7.3-3.094a17.93 17.93 0 0 1-1.773-.652A13.839 13.839 0 0 1 7.5 12.838a6.006 6.006 0 0 1-1.27-3.2 3.465 3.465 0 0 1 1.086-2.584 1.145 1.145 0 0 1 .829-.387c.207 0 .415 0 .6.011h.07c.181 0 .407 0 .63.53.259.62.881 2.144.959 2.3a.568.568 0 0 1 .026.542 2.112 2.112 0 0 1-.311.516c-.156.181-.327.4-.467.542-.156.154-.318.322-.136.632a9.333 9.333 0 0 0 1.73 2.144 8.5 8.5 0 0 0 2.5 1.536c.311.155.492.129.674-.077s.778-.9.985-1.214.415-.258.7-.155 1.814.852 2.125 1.007.518.232.6.362a2.576 2.576 0 0 1-.181 1.472 3.2 3.2 0 0 1-2.1 1.472 5.108 5.108 0 0 1-.755.059 3.964 3.964 0 0 1-1.21-.182z"
})));
/* harmony default export */ var whats_app = (SvgWhatsApp);
// EXTERNAL MODULE: ../../../libs/landing/feature-support/src/lib/components/contact-card/contact-card.module.css
var contact_card_module = __webpack_require__(12694);
var contact_card_module_default = /*#__PURE__*/__webpack_require__.n(contact_card_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-support/src/lib/components/contact-card/contact-card.tsx












// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SvgComponent = {
    mail: mail,
    phone: phone,
    smartphone: smartphone,
    whatsapp: whats_app
};
const ContactCard = ({ svgType , heading , body , cta , category , href , shouldHideOnDesktop =false  })=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared_src/* Panel */.s_, {
        className: classnames_default()((contact_card_module_default()).panel, shouldHideOnDesktop && (contact_card_module_default()).hiddenDesktop),
        classNames: {
            body: (contact_card_module_default()).panelFlex
        },
        isPadded: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (contact_card_module_default()).iconWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* SVG */.Wj, {
                    children: SvgComponent[svgType.toLocaleLowerCase()],
                    width: 32,
                    height: 32
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (contact_card_module_default()).textContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: (contact_card_module_default()).panelHeading,
                        children: heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (contact_card_module_default()).textWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontSize: "xs",
                            fontWeight: "book",
                            children: body
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: `${href ? href : cta}`,
                        "aria-label": cta,
                        className: (contact_card_module_default()).link,
                        onClick: ()=>handleTrackingClick(trackEvent, {
                                eventName: "Support - click contact card",
                                label: cta,
                                category: category
                            }),
                        children: cta
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var contact_card = (ContactCard);

;// CONCATENATED MODULE: ../../../libs/landing/feature-support/src/lib/data/storyblok-renderer-map.ts

const storyblokComponents = {
    FaqSection: shared_src/* FaqAccordion */.eo
};

// EXTERNAL MODULE: ../../../libs/landing/feature-support/src/lib/components/faqs/support-faqs.module.css
var support_faqs_module = __webpack_require__(40612);
var support_faqs_module_default = /*#__PURE__*/__webpack_require__.n(support_faqs_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-support/src/lib/components/faqs/support-faqs.tsx





const SupportFaqs = ({ faqs  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (support_faqs_module_default()).supportFaqs,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                element: "h2",
                fontSize: "xxl",
                fontWeight: "bold",
                children: "Got a Q? We’ve got the A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                children: "Find everything from how we pick our cars to the different ways you can pay for one."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                block: faqs,
                components: storyblokComponents
            })
        ]
    });
/* harmony default export */ var support_faqs = (SupportFaqs);

// EXTERNAL MODULE: ../../../node_modules/next/router.js
var next_router = __webpack_require__(35837);
// EXTERNAL MODULE: ../../../libs/landing/feature-support/src/lib/components/pre-footer/support-pre-footer.module.css
var support_pre_footer_module = __webpack_require__(8128);
var support_pre_footer_module_default = /*#__PURE__*/__webpack_require__.n(support_pre_footer_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-support/src/lib/components/pre-footer/support-pre-footer.tsx







const SupportPreFooter = ()=>{
    const router = (0,next_router.useRouter)();
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const { footerCta , footerHeading  } = supportContactContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: (support_pre_footer_module_default()).ctaContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (support_pre_footer_module_default()).textWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        element: "h2",
                        fontSize: "m",
                        fontWeight: "semibold",
                        children: footerHeading
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                    onClick: ()=>{
                        handleTrackingClick(trackEvent, {
                            eventName: "click",
                            category: "button",
                            label: footerCta
                        });
                        router.push("/used-cars");
                    },
                    children: footerCta
                })
            ]
        })
    });
};
/* harmony default export */ var support_pre_footer = (SupportPreFooter);

// EXTERNAL MODULE: ../../../libs/landing/feature-support/src/lib/components/help-and-support/help-and-support.module.css
var help_and_support_module = __webpack_require__(38357);
var help_and_support_module_default = /*#__PURE__*/__webpack_require__.n(help_and_support_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-support/src/lib/components/help-and-support/help-and-support.tsx









const callUsPhoneNumberDigits = (str)=>str.replace(/\D/g, "");
const HelpAndSupport = ({ faqs  })=>{
    const { whatsAppHeading , whatsAppHref , smsHref , whatsAppBody , whatsAppCta , textHeading , textBody , textCta , emailHeading , emailBody , emailCta , emailHref , callHeading , callBody , callCta  } = supportContactContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (help_and_support_module_default()).title,
                        children: "Help and support"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (help_and_support_module_default()).panels,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_card, {
                                svgType: "whatsapp",
                                heading: whatsAppHeading,
                                body: whatsAppBody,
                                cta: whatsAppCta,
                                category: "whatsApp",
                                href: whatsAppHref,
                                shouldHideOnDesktop: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_card, {
                                svgType: "smartphone",
                                heading: textHeading,
                                body: textBody,
                                cta: textCta,
                                href: smsHref,
                                category: "text",
                                shouldHideOnDesktop: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_card, {
                                svgType: "mail",
                                heading: emailHeading,
                                body: emailBody,
                                cta: emailCta,
                                href: emailHref,
                                category: "email"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_card, {
                                svgType: "phone",
                                heading: callHeading,
                                body: callBody,
                                cta: callUsPhoneNumberDigits(callCta),
                                href: `tel:${callCta}`,
                                category: "phone"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(complaints, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (help_and_support_module_default()).faqWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(support_faqs, {
                            faqs: faqs
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(support_address, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(support_pre_footer, {})
        ]
    });
};
/* harmony default export */ var help_and_support = (HelpAndSupport);

;// CONCATENATED MODULE: ../../../libs/landing/feature-support/src/lib/support-page.tsx




const SupportPage = ({ story , preview , generatedAt  })=>{
    const typedStory = story;
    const { content  } = (0,src/* useStoryblokState */.f0)({
        story: typedStory,
        enableBridge: preview
    });
    const SEO = Array.isArray(content === null || content === void 0 ? void 0 : content.SEO) && content.SEO[0];
    const FAQs = content.faqs;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                ...SEO,
                generatedAt: generatedAt,
                fallbackTitle: "Support - cinch",
                fallbackDescription: "Whether you have a specific query (or a more general one), we’re here to help. Check out the links at the bottom of the page, head to our FAQs, or get in touch with us the way that’s easiest for you."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(help_and_support, {
                faqs: FAQs
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var datadog_server_src = __webpack_require__(86634);
;// CONCATENATED MODULE: ../../../libs/landing/feature-support/src/lib/get-static-props.ts


async function getStaticPropsfn({ preview =false  }) {
    try {
        var ref, ref1;
        const story = await (0,src/* getStoryBySlug */.OI)("support", {
            version: preview ? "draft" : "published"
        });
        const HeroProps = story === null || story === void 0 ? void 0 : (ref = story.content) === null || ref === void 0 ? void 0 : (ref1 = ref.hero) === null || ref1 === void 0 ? void 0 : ref1[0];
        (0,datadog_server_src/* setTag */.YA)("response.code", 200);
        (0,datadog_server_src/* setTag */.YA)("page.name", "support");
        (0,datadog_server_src/* setTag */.YA)("page.rendered", "ISR");
        (0,datadog_server_src/* setTag */.YA)("page.revalidate-in", "300s");
        (0,datadog_server_src/* setTag */.YA)("page.params", JSON.stringify({
            preview
        }, null, 2));
        return {
            props: {
                story,
                preview,
                generatedAt: Date.now(),
                layoutProps: {
                    heroProps: HeroProps,
                    showBorderRadius: true
                }
            },
            revalidate: 300
        };
    } catch (error) {
        if (typeof error === "string" || error instanceof Error) {
            (0,datadog_server_src/* tagError */.$k)(error);
        }
        return {
            props: {
                story: null,
                preview,
                generatedAt: Date.now(),
                layoutProps: {
                    heroProps: [],
                    showBorderRadius: true
                }
            },
            revalidate: 300
        };
    }
}
const getStaticProps = (0,datadog_server_src/* traceFunction */.KG)("support.getStaticProps", getStaticPropsfn);

;// CONCATENATED MODULE: ../../../libs/landing/feature-support/src/index.ts



;// CONCATENATED MODULE: ./pages/support.tsx
var __N_SSG = true;



/***/ }),

/***/ 39903:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"support-address_sectionContainer__awbid","textWrapper":"support-address_textWrapper__9MB8I"};

/***/ }),

/***/ 18086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"press":"complaints_press__jS8q4","complaints":"complaints_complaints__hg2Uf","complaintsParagraphsWrapper":"complaints_complaintsParagraphsWrapper__ZTcqI","paragraph":"complaints_paragraph__rvrbO","heading":"complaints_heading__VP7RX","link":"complaints_link__3E2jp","complaintsContactTable":"complaints_complaintsContactTable__tewsu","complaintsAddress":"complaints_complaintsAddress__5QbGV","textWrapper":"complaints_textWrapper__sFFrW"};

/***/ }),

/***/ 12694:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"panel":"contact-card_panel__6Mys8","hiddenDesktop":"contact-card_hiddenDesktop__66Hwm","panelHeading":"contact-card_panelHeading__v61Q8","textWrapper":"contact-card_textWrapper__f4JgR","iconWrapper":"contact-card_iconWrapper__zxUj_","panelFlex":"contact-card_panelFlex__YvogO","textContainer":"contact-card_textContainer__uEybv","link":"contact-card_link__NhYTN"};

/***/ }),

/***/ 40612:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"supportFaqs":"support-faqs_supportFaqs__9R04A"};

/***/ }),

/***/ 38357:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"panels":"help-and-support_panels__XSxaO","title":"help-and-support_title__vNSQ4","faqWrapper":"help-and-support_faqWrapper__nRq63"};

/***/ }),

/***/ 8128:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"support-pre-footer_textWrapper__MxobK","ctaContainer":"support-pre-footer_ctaContainer__weRro","ctaButton":"support-pre-footer_ctaButton__RT4qJ"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(90017); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);